import pre from './pre';
import config from './config/index.vue';
import cart from './cart.vue';
import addon from './addon.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    config,
    cart,
    addon,
    success,
  },
  post: () => { },
}
